<!-- 运行日志 -->
<template>
    <div class="content">
        <div class="pl-pannel bg-w bdrd10 pdv20 pdh30 unselect">
            <div class="pl-title lh50 xrow ai-c jc-sb">
                <div class="xrow ai-c">
                    <p class="fw-bd lh34 mgr15">采集时间</p>
                    <el-date-picker v-model="queryDate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                    </el-date-picker>
                    <el-button type="primary" icon="el-icon-search" class="mgl15">查询</el-button>
                </div>
            </div>
            <div class="pl-content pdt20">
                <el-table :data="tableData" stripe style="width: 100%" header-row-class-name="headercolumn" cell-class-name="datarow" :row-class-name="tableRowClassName">
                    <el-table-column prop="rowNum" label="序号" width="120">
                    </el-table-column>
                    <el-table-column prop="name" label="传感器名" width="180">
                    </el-table-column>
                    <el-table-column prop="latestvalue" label="采集值">
                    </el-table-column>
                    <el-table-column prop="reporttime" label="采集时间">
                    </el-table-column>
                    <el-table-column prop="alarmstate" label="报警状态">
                    </el-table-column>
                    <el-table-column prop="eventtype" label="报警事件">
                    </el-table-column>
                    <el-table-column prop="address" label="报警时间">
                    </el-table-column>
                </el-table>
            </div>
            <div class="pl-footer xrow ai-c jc-sb mgt20">
                <div class="paging-memo">检索到 105 条记录，显示 第1条 - 第206条，查询耗时 15 毫秒</div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-sizes="[50 ,100, 200, 300, 400]" layout="total, prev, pager, next, jumper"
                    :total="1000">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tableData: [],
            pageRows: 50,
            pageIndex: 1,
            queryDate: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            )
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            )
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            )
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            }
        }
    },

    components: {},

    computed: {},

    mounted() {},

    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 0) {
                return 'bg-w'
            } else {
                return 'bg-mf5'
            }
        },
        handleSizeChange() {},
        handleCurrentChange() {}
    }
}
</script>
<style lang='less' scoped>
.content {
    position: relative;
    left: 165px;
    top: 90px;
    width: calc(100vw - 175px);
    height: calc(100vh - 90px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 30px;
}
.headercolumn {
    th {
        padding: 0 0;
        line-height: 45px;
        background-color: #e2eff6;
        color: #000;
        text-align: center;
        font-size: 14px;
    }
}
.datarow {
    text-align: center;
    line-height: 45px;
    color: #181b24;
    font-size: 14px;
}
.el-table .bg-mf5 > td {
    background-color: #f5f9fa !important;
    border-bottom: none;
}
.el-table .bg-w > td {
    background-color: #fff !important;
    border-bottom: none;
}
</style>
